import React from 'react';
import { StyleSheet, TouchableOpacity, View, Text } from 'react-native';
import { s } from 'react-native-wind';
import { useLanguage } from '../../../locale';
import { Survey } from '../../../api/survey/survey.models';

interface SurveyCardProps {
  survey: Survey;
  onCardPress?: () => void;
}

export const SurveyCard: React.FC<SurveyCardProps> = ({
  survey,
  onCardPress,
}) => {
  const [t] = useLanguage();
  // Content is already localized from the server
  const content = survey.localizedContent;

  return (
    <TouchableOpacity
      style={[styles.container, s`bg-card rounded-xl p-4`]}
      onPress={onCardPress}
      disabled={!onCardPress}
    >
      <View style={s`flex-row justify-between items-start`}>
        <View style={s`flex-1`}>
          <Text style={[styles.title, s`text-text-primary`]}>
            {content.title}
          </Text>
          <Text 
            style={styles.description}
            numberOfLines={2}
            ellipsizeMode="tail"
          >
            {content.description}
          </Text>
        </View>
        <View style={s`ml-2`}>
          <View
            style={[
              styles.statusBadge,
              survey.isCompleted ? styles.completedBadge : styles.pendingBadge,
            ]}
          >
            <Text style={[styles.statusText, s`text-white`]}>
              {survey.isCompleted ? t('survey.completed') : t('survey.pending')}
            </Text>
          </View>
        </View>
      </View>
      
      {/* Navigation arrow in bottom right - using flexbox positioning */}
      <View style={styles.bottomRow}>
        <View style={styles.spacer} />
        <Text style={styles.arrow}>→</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    // Removed shadow properties for cleaner design
    minHeight: 80, // Fixed minimum height for consistency
  },
  title: {
    fontSize: 16,
    fontWeight: '600', // Changed to semibold
  },
  description: {
    marginTop: 4,
    fontSize: 14,
    fontWeight: 'normal', // Explicitly set to regular
    lineHeight: 20, // Fixed line height for consistent spacing
    height: 40, // Fixed height for exactly 2 lines (20px * 2)
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusText: {
    fontSize: 12,
  },
  completedBadge: {
    backgroundColor: '#4CAF50',
  },
  pendingBadge: {
    backgroundColor: '#FF9800',
  },
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 8,
  },
  spacer: {
    flex: 1,
  },
  arrow: {
    fontSize: 16,
    color: '#9CA3AF',
    fontWeight: '500',
  },
});
